import { render, staticRenderFns } from "./xieCheDialog.vue?vue&type=template&id=3506f998&scoped=true&"
import script from "./xieCheDialog.vue?vue&type=script&lang=js&"
export * from "./xieCheDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506f998",
  null
  
)

export default component.exports